import { render, staticRenderFns } from "./frmelfelejtettjelszo.vue?vue&type=template&id=2c1232b2&scoped=true&"
import script from "./frmelfelejtettjelszo.vue?vue&type=script&lang=js&"
export * from "./frmelfelejtettjelszo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1232b2",
  null
  
)

export default component.exports